import * as PrefabManager from '../PrefabManager';
import {
    game
} from "../../Game";
import { Settings } from '../../Settings';
import { b2CloneVec2 } from '../../../libs/debugdraw';
import { crawlJointsUtility } from '../level/Finish';

const vec1 = new Box2D.b2Vec2();

class Slower extends PrefabManager.basePrefab {

    constructor(target) {
        super(target);
    }
    init(){
        super.init();
        this.base = this.lookupObject['base'];
        this.velocityBoost = -0.5 / Settings.timeStep;

        if(this.prefabObject.settings.isFixed){
            this.base.SetType(Box2D.b2_staticBody);
        }else{
            this.base.SetType(Box2D.b2_dynamicBody);
        }
    }
    initContactListener() {
        super.initContactListener();
        const self = this;
        this.contactListener.PostSolve = function(contact) {
            const otherBody = contact.GetFixtureA().GetBody() === self.base ? contact.GetFixtureB().GetBody() : contact.GetFixtureA().GetBody();

            let bodies =  crawlJointsUtility(otherBody, ()=>true);
            bodies.push(otherBody);

            const direction = self.base.GetAngle();
            const deltaVelocityInc = self.velocityBoost*game.editor.deltaTime;
            const velocityInc = new Box2D.b2Vec2(deltaVelocityInc*Math.cos(direction), deltaVelocityInc*Math.sin(direction));

            bodies.forEach(body=> {
                if(body.GetType() !== Box2D.b2_staticBody){
                    const velocity = vec1;
                    velocity.Set(body.GetLinearVelocity().x, body.GetLinearVelocity().y);
                    velocity.set_x(velocity.get_x() + velocityInc.x);
                    velocity.set_y(velocity.get_y() + velocityInc.y);
                    body.SetLinearVelocity(velocity);
                }
            })

        }
    }
}

Slower.settings = Object.assign({}, Slower.settings, {
    "isFixed": false,
});
Slower.settingsOptions = Object.assign({}, Slower.settingsOptions, {
	"isFixed": false,
});

PrefabManager.prefabLibrary.Slower = {
    json: '{"objects":[[0,-0.122,0.061,0,"booster","base",0,["#999999"],["#000"],[0],false,true,[[{"x":-5.218,"y":0.428},{"x":-5.218,"y":-0.428},{"x":5.218,"y":-0.428},{"x":5.218,"y":0.428}]],[1],0,[0],"",[1],true,false,false],[1,-4.28,1.223,0,"booster","texture",1,"Slower0000",0,0.865,2.356,0,false,"#FFFFFF",1,1,1,0,0,0,true]]}',
    class: Slower,
    library: PrefabManager.LIBRARY_MOVEMENT
}
